import React, { useState, useEffect } from 'react';
import { API } from '../contexts/AuthContext';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [filiais, setFiliais] = useState([]);
  const [busca, setBusca] = useState('');
  const [resultados, setResultados] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState('');
  const [loading, setLoading] = useState(true);

  const carregar = () => {
    Promise.all([
      axios.get(`${API}/usuarios`),
      axios.get(`${API}/perfis`),
      axios.get(`${API}/filiais`)
    ]).then(([u, p, f]) => {
      setUsuarios(u.data);
      setPerfis(p.data);
      setFiliais(f.data);
    }).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(carregar, []);

  const nomeFilial = (codigo) => filiais.find(f => String(f.codigo) === String(codigo))?.nome || '';

  const buscarUsuarios = async () => {
    if (busca.length < 2) return;
    const res = await axios.get(`${API}/usuarios/buscar?nome=${busca}`);
    setResultados(res.data);
  };

  const vincular = async (usuario_id) => {
    if (!perfilSelecionado) return Swal.fire('Atenção', 'Selecione um perfil', 'warning');
    await axios.post(`${API}/usuarios/vincular`, { usuario_id, perfil_id: parseInt(perfilSelecionado) });
    Swal.fire({ icon: 'success', title: 'Vinculado!', timer: 1500, showConfirmButton: false });
    setResultados([]);
    setBusca('');
    carregar();
  };

  const desvincular = async (id, nome) => {
    const r = await Swal.fire({ title: `Desvincular ${nome}?`, icon: 'warning', showCancelButton: true, confirmButtonText: 'Sim', cancelButtonText: 'Cancelar', confirmButtonColor: '#6B2C5C' });
    if (!r.isConfirmed) return;
    await axios.delete(`${API}/usuarios/${id}`);
    carregar();
  };

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;

  return (
    <div>
      <h4 className="fw-bold mb-4">Usuários</h4>

      <div className="card p-3 mb-4">
        <h6 className="fw-bold mb-3">Vincular Novo Usuário</h6>
        <div className="row g-2 align-items-end">
          <div className="col-md-4">
            <label className="form-label" style={{ fontSize: '0.85rem' }}>Buscar por nome</label>
            <input className="form-control" value={busca} onChange={e => setBusca(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && buscarUsuarios()} placeholder="Digite o nome..." />
          </div>
          <div className="col-md-3">
            <label className="form-label" style={{ fontSize: '0.85rem' }}>Perfil</label>
            <select className="form-select" value={perfilSelecionado} onChange={e => setPerfilSelecionado(e.target.value)}>
              <option value="">Selecione...</option>
              {perfis.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
            </select>
          </div>
          <div className="col-md-2">
            <button className="btn-primary-mkt w-100" onClick={buscarUsuarios}>Buscar</button>
          </div>
        </div>
        {resultados.length > 0 && (
          <div className="mt-3">
            {resultados.map(u => (
              <div key={u.id} className="d-flex align-items-center justify-content-between py-2 border-bottom">
                <span>{u.nome} {u.filial ? <small className="text-muted">({nomeFilial(parseInt(u.filial))})</small> : ''}</span>
                <button className="btn-primary-mkt btn-sm" onClick={() => vincular(u.id)}>Vincular</button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="card p-3">
        <h6 className="fw-bold mb-3">Usuários Vinculados</h6>
        <div className="tabela-container">
          <table className="table table-mkt table-hover mb-0">
            <thead>
              <tr><th>Nome</th><th>Perfil</th><th>Filial</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id}>
                  <td>{u.usuario_nome}</td>
                  <td>{u.perfil_nome}</td>
                  <td>{u.filial ? nomeFilial(parseInt(u.filial)) : '—'}</td>
                  <td>{u.ativo ? <span className="badge-ativa">Ativo</span> : <span className="badge-encerrada">Inativo</span>}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => desvincular(u.id, u.usuario_nome)}>
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
